const criptos = [
  {
    type: 'USDT TRC20',
    label: 'USDT TRC20',
    depositInfo: {
      "crypto": "USDT TRC20",
      "isin": "USDT TRC20",
      "address": "TXt3vanU5vBDjppatrUyuRgPW6hdKtngcx",
      "tag": null,
      "deposit_minimum": "USD₮ 5.00",
      "deposit_fixed_fee": "free",
      "deposit_var_fee": "free",
      "withdraw_minimum": "",
      "withdraw_fixed_fee": "$2.50",
      "withdraw_var_fee": "",
    },
    withdrawalInfo: {
      method: 'USDT TRC20',
      short: 'USDT TRC20',
      fixed_fee: 2.50,
      var_fee: 0.95
    }
  },
  {
    type: 'USDT ERC20',
    label: 'USDT ERC20',
    depositInfo: {
      "crypto": "USDT ERC20",
      "isin": "USDT ERC20",
      "address": "0x011a9143bfd12dd6ffd4e1e1d1e93e77351b4b93",
      "tag": null,
      "deposit_minimum": "USD₮ 5.00",
      "deposit_fixed_fee": "free",
      "deposit_var_fee": "free",
      "withdraw_minimum": "",
      "withdraw_fixed_fee": "$6.50",
      "withdraw_var_fee": "",
    },
    withdrawalInfo: {
      method: 'USDT ERC20',
      short: 'USDT ERC20',
      fixed_fee: 6.50,
      var_fee: 0.95
    }
  },
  {
    type: 'USDT BEP20',
    label: 'USDT BEP20',
    depositInfo: {
      "crypto": "USDT BEP20",
      "isin": "USDT BEP20",
      "address": "0x011a9143bfd12dd6ffd4e1e1d1e93e77351b4b93",
      "tag": null,
      "deposit_minimum": "USD₮ 5.00",
      "deposit_fixed_fee": "free",
      "deposit_var_fee": "free",
      "withdraw_minimum": "",
      "withdraw_fixed_fee": "$1.50",
      "withdraw_var_fee": "",
    },
    withdrawalInfo:  {
      method: 'USDT BEP20',
      short: 'USDT BEP20',
      fixed_fee: 1.50,
      var_fee: 0.95
    }
  },
  {
    type: 'USDT Polygon',
    label: 'USDT Polygon',
    depositInfo: {
      "crypto": "USDT Polygon",
      "isin": "USDT Polygon",
      "address": "0x011a9143bfd12dd6ffd4e1e1d1e93e77351b4b93",
      "tag": null,
      "deposit_minimum": "USD₮ 5.00",
      "deposit_fixed_fee": "free",
      "deposit_var_fee": "free",
      "withdraw_minimum": "",
      "withdraw_fixed_fee": "$2.00",
      "withdraw_var_fee": "",
    },
    withdrawalInfo:  {
      method: 'USDT Polygon',
      short: 'USDT Polygon',
      fixed_fee: 2.00,
      var_fee: 0.95
    }
  },
  {
    type: 'USDC ERC20',
    label: 'USDC ERC20',
    depositInfo: {
      "crypto": "USDC ERC20",
      "isin": "USDC ERC20",
      "address": "0x011a9143bfd12dd6ffd4e1e1d1e93e77351b4b93",
      "tag": null,
      "deposit_minimum": "USDC 5.00",
      "deposit_fixed_fee": "free",
      "deposit_var_fee": "free",
      "withdraw_minimum": "",
      "withdraw_fixed_fee": "$6.50",
      "withdraw_var_fee": "",
    },
    withdrawalInfo:  {
      method: 'USDC ERC20',
      short: 'USDC ERC20',
      fixed_fee: 6.50,
      var_fee: 0.95
    }
  },
  {
    type: 'USDC BEP20',
    label: 'USDC BEP20',
    depositInfo: {
      "crypto": "USDC BEP20",
      "isin": "USDC BEP20",
      "address": "0x011a9143bfd12dd6ffd4e1e1d1e93e77351b4b93",
      "tag": null,
      "deposit_minimum": "USDC 5.00",
      "deposit_fixed_fee": "free",
      "deposit_var_fee": "free",
      "withdraw_minimum": "",
      "withdraw_fixed_fee": "$1.50",
      "withdraw_var_fee": "",
    },
    withdrawalInfo:  {
      method: 'USDC BEP20',
      short: 'USDC BEP20',
      fixed_fee: 1.50,
      var_fee: 0.95
    }
  },
  {
    type: 'USDC Polygon',
    label: 'USDC Polygon',
    depositInfo: {
      "crypto": "USDC Polygon",
      "isin": "USDC Polygon",
      "address": "0x011a9143bfd12dd6ffd4e1e1d1e93e77351b4b93",
      "tag": null,
      "deposit_minimum": "USDC 5.00\n",
      "deposit_fixed_fee": "free",
      "deposit_var_fee": "free",
      "withdraw_minimum": "",
      "withdraw_fixed_fee": "$2.00",
      "withdraw_var_fee": "",
    },
    withdrawalInfo:  {
      method: 'USDC Polygon',
      short: 'USDC Polygon',
      fixed_fee: 2.00,
      var_fee: 0.95
    }
  },
]
export function getCriptoList(){
  return criptos
}

export function getCriptoWithdrawalInfo() {
  return criptos.map( el => el.withdrawalInfo)
}
